import authFactory from "@/logic/auth/authFactory";

const instance = authFactory({
  authApi: {
    baseURL: window.APP_CONFIG.api.auth,
  },
});

export default instance;
